import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["cardContentText", "cardTitle", "checked", "circleCheck", "focalPointImage", "imageAltText", "imagePath"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CheckCircle, CheckCircleOutline } from '@mui/icons-material';
import { Checkbox, CardMedia, Typography, Grid, styled } from '@mui/material';
import React from 'react';
import ImageLeftCardHeader from './ImageLeftCardHeader';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import FocalPointImage from '../../templates/FocalPointImage';
export var CustomCardContent = styled('div')(function () {
  return {
    padding: '0px'
  };
});

var ImageLeftLayout = function ImageLeftLayout(_ref) {
  var cardContentText = _ref.cardContentText,
      cardTitle = _ref.cardTitle,
      checked = _ref.checked,
      circleCheck = _ref.circleCheck,
      focalPointImage = _ref.focalPointImage,
      imageAltText = _ref.imageAltText,
      imagePath = _ref.imagePath,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(Grid, {
    container: true,
    columns: 16
  }, React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(CustomCardContent, null, !focalPointImage ? React.createElement(CardMedia, {
    component: "img",
    image: imagePath,
    alt: imageAltText,
    sx: {
      height: '113.93px'
    }
  }) : React.createElement(CardMedia, {
    sx: {
      height: '113.93px'
    }
  }, React.createElement(FocalPointImage, _objectSpread({}, focalPointImage))))), React.createElement(Grid, {
    container: true,
    item: true,
    xs: 10,
    spacing: 0,
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Grid, {
    item: true,
    xs: circleCheck ? 12 : 16
  }, React.createElement(ImageLeftCardHeader, {
    cardTitle: cardTitle,
    cardContentText: cardContentText
  })), circleCheck ? React.createElement(Grid, {
    item: true,
    xs: 4,
    sx: {
      display: 'flex',
      alignContent: 'center',
      px: 1.5,
      justifyContent: 'right'
    }
  }, React.createElement(Checkbox, _objectSpread({
    icon: React.createElement(CheckCircleOutline, null),
    checkedIcon: React.createElement(CheckCircle, null),
    checked: checked
  }, props))) : null, cardContentText ? React.createElement(Grid, {
    item: true,
    xs: 16
  }, React.createElement(CustomCardContent, null, React.createElement(Typography, {
    sx: [ASPENDENTAL_FONTS.bodySmallBook, {
      px: 2,
      pb: 1,
      color: 'text.secondary'
    }]
  }, cardContentText))) : null));
};

export default ImageLeftLayout;